import { ActionIcon, Group, Text } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const WeekSelector = () => {

	// State and hooks
	const [currentIndex, setCurrentIndex] = useState(0);
	const [displayedWeek, setDisplayedWeek] = useState([]);
	const { userEvolution } = useSelector(state => state.dashboardData);
	const dispatch = useDispatch();

	// On change, display first week
	useEffect(() => {
		if (userEvolution) updateDisplayedWeek(userEvolution, 0);
		// eslint-disable-next-line
	}, [userEvolution]);

	// Update the week
	const updateDisplayedWeek = (data, startIndex) => {

		// Get the week and change
		const week = data.slice(startIndex, startIndex + 7);
		setDisplayedWeek(week);

		// Update in global state
		dispatch.dashboardData.setUserEvolutionWeekRange(week);

	}

	// Get previous week
	const handlePrevious = () => {

		// Get the index
		const newIndex = Math.max(currentIndex - 7, 0);

		// Update
		setCurrentIndex(newIndex);
		updateDisplayedWeek(userEvolution, newIndex);

	}

	// Get next week
	const handleNext = () => {

		// Get the index
		const newIndex = Math.min(currentIndex + 7, userEvolution.length - 1);

		// Update
		setCurrentIndex(newIndex);
		updateDisplayedWeek(userEvolution, newIndex);

	}

	// Format the selected range
	const formatDateRange = () => {

		// If there are no weeks, return empty
		if (displayedWeek.length === 0) return '';

		// Get start and end dates
		const start = new Date(displayedWeek[0].date);
		const end = new Date(displayedWeek[displayedWeek.length - 1].date);

		// Format the dates
		const formatter = new Intl.DateTimeFormat('es-AR', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });

		// Return the formatted range
		return `${formatter.format(start)} - ${formatter.format(end)}`;

	};

	return (
		<Group
			w="100%"
			position="apart"
			px={40}
			pb={8}
		>
			{/* Previous */}
			<ActionIcon
				onClick={handlePrevious}
				disabled={currentIndex === 0}
			>
				<IconChevronLeft />
			</ActionIcon>
			{/* Selected Week */}
			<Text
				fz={14}
				tt="capitalize"
			>
				{formatDateRange()}
			</Text>
			{/* Next */}
			<ActionIcon
				onClick={handleNext}
				disabled={currentIndex >= userEvolution.length - 7}
			>
				<IconChevronRight />
			</ActionIcon>
		</Group>
	);

}

export default WeekSelector;
